import * as React from 'react';
import { DialogContent, Grid } from '@mui/material';
import { useEffect, useState } from 'react';
import { AppContext } from '../../context/AppContext';
import BakeasyHeaderLabel from '../../components/labels/BakeasyHeaderLabel';
import * as Button from '../../components/buttons/BakeasyButtons';
import BakeasySimpleTable from '../../components/tables/BakeasySimpleTable';
import { useLocation, useNavigate } from 'react-router-dom';
import { HeadCell } from '../../components/tables/BakeasyTable';
import {
  clearDraftOrdersState,
  deleteDraftOrderById,
  draftOrderState,
  draftorders,
  fetchDraftOrderById,
  fetchdraftOrders,
} from '../../redux_store/slices/draftOrdersSlice';
import { useAppDispatch, useAppSelector } from '../../redux_store/reduxStore';
import {
  clearCreateOrdersState,
  createorders,
} from '../../redux_store/slices/createOrdersSlice';
import BakeasyTextField from '../../components/textfields/BakeasyTextField';
import BakeasyDatePicker from '../../components/common/BakeasyDatePicker';
import * as Dropdown from '../../components/dropdowns/BakeasySelect';
import dayjs, { Dayjs } from 'dayjs';
import { t } from 'i18next';
import BakeasyDivider from '../../components/common/BakeasyDivider';
import { storeState } from '../../redux_store/slices/storeSlice';
import * as TextField from '../../components/textfields/BakeasyTextFields';
import { taxesState } from '../../redux_store/slices/taxesSlice';
import {
  isParsableToFloat,
  preparePostalCode,
  removePercentageFromTax,
  validateField,
} from '../../utils/ValidationUtils';
import { clearOrderHistoryState } from '../../redux_store/slices/OrderHistorySlice';
import i18n from '../../languages/languages';
import * as Regex from '../../constants/Regex';
import {
  countryState,
  fetchCountries,
} from '../../redux_store/slices/countriesSlice';
import {
  clearStatesState,
  fetchStates,
  statesState,
} from '../../redux_store/slices/statesSlice';
import {
  BakeasyAutoCompleteCountry,
  BakeasyAutoCompleteState,
} from '../../components/dropdowns/BakeasyAutoComplete';
import { shippingMethodsState } from '../../redux_store/slices/shippingMethodsSlice';
import { showErrorSnackbar } from '../../redux_store/slices/snackbarSlice';
import { formatDateTime } from '../../utils/DateUtils';

export const NewOrderSummary = (props: any) => {
  let myContext = React.useContext(AppContext);
  const navigate = useNavigate();
  const { state } = useLocation();
  const dispatch = useAppDispatch();
  let _taxesState = useAppSelector(taxesState);

  const [splitOrders, setSplitOrders] = useState<any>([]);
  const [description, setDescription] = useState<any>('');
  const [orderDetails, setOrderDetails] = useState<any>();
  const [ordersList, setOrdersList] = useState<any[]>(
    state?.selectedOrders?.length ? state.selectedOrders : []
  );
  const [id, setID] = useState('');
  const [total, setTotal] = useState<any>([{}]);
  const [orderBy, setorderBy] = useState('');
  const [poNumber, setPoNumber] = useState<any>();
  const [requestedDeliveryDate, setRequestedDeliveryDate] =
    useState<Dayjs | null>(null);
  const [selectedPriority, setSelectedPriority] = useState<any>('');
  const [note, setNote] = useState('');
  const [supplierName, setSupplierName] = useState('');

  const [selectedShipTo, setSelectedShipTo] = useState<any>('');
  const [shipToName, setShipToName] = useState<any>('');
  const [shipToCompanyName, setShipToCompanyName] = useState<any>('');
  const [shipToAddress, setShipToAddress] = useState<any>('');
  const [shipToCity, setShipToCity] = useState<any>('');
  const [shipToPostCode, setShipToPostCode] = useState<any>('');
  const [shipToCountry, setShipToCountry] = useState<any>(null);
  const [shipToState, setShipToState] = useState<any>('');

  const [preferredShippingMethod, setPreferredShippingMethod] =
    useState<any>('');
  const [selectedPreferredShippingMethod, setSelectedPreferredShippingMethod] =
    useState<any>('');
  const [shipToType, setShipToType] = useState<string>('');

  const [selectedShippingCharge, setSelectedShippingCharge] = useState<any>('');
  const [selectedShippingCalculation, setSelectedShippingCalculation] =
    useState<any>('');
  const [shippingCharges, setShippingCharges] = useState<any>('');

  const [selectedTaxRate1, setSelectedTaxRate1] = useState<any>(null);
  const [selectedTaxRate2, setSelectedTaxRate2] = useState<any>(null);

  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState<any>('');
  const [selectedPaymentTerm, setSelectedPaymentTerm] = useState<any>('');

  let _storeState = useAppSelector(storeState);
  let _draftOrder = useAppSelector(draftOrderState);
  let _countryState = useAppSelector(countryState);
  let _statesState = useAppSelector(statesState);
  let _shippingMethodsState = useAppSelector(shippingMethodsState);

  function handleClose() {
    myContext.setDialog({ open: false });
    navigate(-1);
    dispatch(clearOrderHistoryState());
  }

  useEffect(() => {
    if (props?.isEdit?.params?.isDraftOrder && _draftOrder?.value?.data[0]) {
      setDetailsData(_draftOrder?.value?.data[0]);
      return;
    }

    if (_storeState?.value) {
      setDetailsData(_storeState?.value);
    }
  }, [_storeState?.value, _draftOrder?.value?.data[0]]);

  useEffect(() => {
    dispatch(fetchDraftOrderById({ id: props?.isEdit?.params?.data?.id }));
    dispatch(fetchCountries({ page: 1, limit: 5, search: '' }));
  }, []);

  useEffect(() => {
    if (props?.isEdit?.params?.data) {
      setData(props?.isEdit?.params?.data);
    }
  }, [props?.isEdit?.params?.data]);

  useEffect(() => {
    if (ordersList?.length > 0) {
      calculateTotalPrice();
    }
  }, [ordersList]);

  const tableHeaders: HeadCell[] = [
    { id: 'productName', label: 'PRODUCT_NAME', width: '200px' },
    { id: 'userProductId', label: 'PRODUCT_ID', width: '160px' },
    { id: 'unitPrice', label: 'UNIT_PRICE', numeric: true, width: '100px' },
    {
      id: 'quantity',
      label: 'QUANTITY',
      width: '100px',
      numeric: true,
      disabled: true,
    },
    { id: 'totalPrice', label: 'TOTAL_PRICE', numeric: true, width: '100px' },
  ];

  function openCancelConfirmDialog() {
    myContext.setConfirmDialog({
      open: true,
      title: t('CONFIRMATION'),
      message: t('ORDER_CANCEL_CONFIRM_MESSAGE'),
      onNoClick: (event: any) => {},
      onYesClick: (event: any, param: string | undefined) => {
        myContext.setDialog({ open: false });
      },
    });
  }

  function setData(data: any) {
    setID(data?.id);
    setSupplierName(data?.supplierName);

    if (data?.products?.length > 0) {
      const orders = data?.products?.map((item: any) => {
        item.unitPrice = item?.price;
        item.totalPrice = (
          Number(item?.quantity) * Number(item?.price)
        ).toFixed(2);
        return item;
      });

      setOrdersList(orders);
    }

    setorderBy(data?.orderBy);
    setPoNumber(data?.poNumber);
    setRequestedDeliveryDate(data?.requestedDeliveryDate);
    setNote(data?.note);
    // setSelectedPriority(data?.selectedPriority ? 'Yes' : 'No');
    setSelectedPriority(data?.priority ? t('YES') : t('NO'));
  }

  const calculateTotalPrice = () => {
    let subTotal1 = ordersList.reduce(
      (total: number, order: { totalPrice: string }) =>
        total + Number(order.totalPrice || 0),
      0
    );

    subTotal1 = parseFloat(subTotal1.toFixed(2));

    const getTaxRate = (taxRate?: string) => {
      if (!taxRate || taxRate === 'Not Applicable') return 0;

      const cleanedTaxRate = removePercentageFromTax(taxRate);

      return isParsableToFloat(cleanedTaxRate) ? parseFloat(cleanedTaxRate) : 0;
    };

    const taxRate1 = getTaxRate(selectedTaxRate1?.taxName);
    const taxRate2 = getTaxRate(selectedTaxRate2?.taxName);

    const calculatedtax1 = parseFloat(
      ((taxRate1 / 100) * subTotal1).toFixed(2)
    );

    const calculatedtax2 = parseFloat(
      ((taxRate2 / 100) * subTotal1).toFixed(2)
    );

    let calculatedshippingCharge = 0;
    if (selectedShippingCharge === 'Yes' || selectedShippingCharge === 'Oui') {
      if (selectedShippingCalculation === 'Percentage') {
        // Example: 2% of 14100 = 282
        calculatedshippingCharge = parseFloat(
          ((subTotal1 * Number(shippingCharges || 0)) / 100).toFixed(2)
        );
      } else if (selectedShippingCalculation === 'Amount') {
        // Example: entered amount = 20
        calculatedshippingCharge = parseFloat(
          Number(shippingCharges || 0).toFixed(2)
        );
      }
    }

    const calculatedtotal = parseFloat(
      (
        subTotal1 +
        calculatedtax1 +
        calculatedtax2 +
        calculatedshippingCharge
      ).toFixed(2)
    );

    setTotal({
      calculatedsubTotal: subTotal1,
      calculatedtax1,
      calculatedtax2,
      calculatedshippingCharge,
      calculatedtotal,
    });
  };

  // const calculateTotalPrice = () => {
  //   let subTotal1: number = ordersList.reduce(
  //     (total: number, order: { totalPrice: string }) => {
  //       return total + parseFloat(order.totalPrice);
  //     },
  //     0
  //   );

  //   subTotal1 = parseFloat(subTotal1.toFixed(2));
  //   let calculatedsubTotal = subTotal1;

  //   const getTaxRate = (taxRate: string | undefined) => {
  //     if (!taxRate || taxRate === 'Not Applicable') return 0;
  //     const cleanedTaxRate = removePercentageFromTax(taxRate);
  //     return isParsableToFloat(cleanedTaxRate) ? parseFloat(cleanedTaxRate) : 0;
  //   };

  //   const taxRate1 = getTaxRate(selectedTaxRate1?.taxName);
  //   const taxRate2 = getTaxRate(selectedTaxRate2?.taxName);

  //   if (isNaN(subTotal1)) subTotal1 = 0;
  //   const safeTaxRate1 = isNaN(taxRate1) ? 0 : taxRate1;
  //   const safeTaxRate2 = isNaN(taxRate2) ? 0 : taxRate2;

  //   const calculatedtax1: number = parseFloat(
  //     ((safeTaxRate1 / 100) * subTotal1).toFixed(2)
  //   );
  //   const calculatedtax2: number = parseFloat(
  //     ((safeTaxRate2 / 100) * subTotal1).toFixed(2)
  //   );

  //   // let calculatedtax1: number =
  //   //   selectedTaxRate1?.taxName !== 'Not Applicable' &&
  //   //   selectedTaxRate1 !== undefined &&
  //   //   isParsableToFloat(selectedTaxRate1?.taxName)
  //   //     ? parseFloat(((parseFloat(selectedTaxRate1?.taxName) / 100) * subTotal1).toFixed(2))
  //   //     : 0;
  //   // let calculatedtax2: number =
  //   //   selectedTaxRate2?.taxName !== 'Not Applicable' &&
  //   //   selectedTaxRate2 !== undefined &&
  //   //   isParsableToFloat(selectedTaxRate2?.taxName)
  //   //     ? parseFloat(((parseFloat(selectedTaxRate2?.taxName) / 100) * subTotal1).toFixed(2))
  //   //     : 0;
  //   // let calculatedtax1: number = parseFloat(((1 / 100) * subTotal1).toFixed(2));
  //   // let calculatedtax2: number = parseFloat(((2 / 100) * subTotal1).toFixed(2));
  //   let calculatedshippingCharge: any = 0;
  //   let calculatedtotal: number = subTotal1 + calculatedtax1 + calculatedtax2;

  //   if (selectedShippingCalculation === 'Percentage') {
  //     calculatedshippingCharge = parseFloat(
  //       ((parseFloat(shippingCharges) / 100) * subTotal1).toFixed(2)
  //     );
  //     calculatedtotal = calculatedtotal + calculatedshippingCharge;
  //   } else if (selectedShippingCalculation === 'Amount') {
  //     // shippingCharges = parseFloat(shippingCharges);
  //     calculatedshippingCharge = t('TO_BE_CONFIRMED');
  //   }

  //   // setTotal({ subTotal, tax1, tax2, shippingCharge, total });
  //   setTotal({
  //     calculatedsubTotal,
  //     calculatedtax1,
  //     calculatedtax2,
  //     calculatedshippingCharge,
  //     calculatedtotal,
  //   });
  // };

  function setDetailsData(data: any) {
    let storeData: any = _storeState?.value;

    setSelectedShipTo(data?.shipTo ?? storeData.shipTo);
    setShipToName(data?.shipToInfo?.name ?? storeData.shipToInfo?.name);
    setShipToCompanyName(
      data?.shipToInfo?.companyName ?? storeData.shipToInfo?.companyName
    );
    setShipToAddress(
      data?.shipToInfo?.companyAddress ?? storeData.shipToInfo?.companyAddress
    );
    setShipToCity(data?.shipToInfo?.city ?? storeData.shipToInfo?.city);

    setShipToPostCode(
      data?.shipToInfo?.zipCode ?? storeData.shipToInfo?.zipCode
    );

    setShipToCountry(
      data?.shipToInfo?.country
        ? { countryName: data?.shipToInfo?.country }
        : { countryName: storeData?.shipToInfo?.country }
    );

    setShipToState(
      data?.shipToInfo?.state
        ? { stateName: data?.shipToInfo?.state }
        : { stateName: storeData?.shipToInfo?.state }
    );

    if (data?.shippingCharges) {
      setSelectedShippingCharge(
        data?.shippingCharges
          ? i18n.language === 'fr'
            ? 'Oui'
            : 'Yes'
          : i18n.language === 'fr'
            ? 'Non'
            : 'No'
      );
    } else {
      setSelectedShippingCharge(
        storeData.shippingCharges
          ? i18n.language === 'fr'
            ? 'Oui'
            : 'Yes'
          : i18n.language === 'fr'
            ? 'Non'
            : 'No'
      );
    }

    setSelectedShippingCalculation(
      data?.shippingRateType ?? storeData.shippingRateType
    );
    setShippingCharges(data?.shippingRate ?? storeData.shippingRate);

    setSelectedPaymentMethod(
      data?.payment?.method ?? storeData.payment?.method
    );
    setSelectedPaymentTerm(data?.payment?.terms ?? storeData.payment?.terms);

    setSelectedTaxRate1(
      data?.taxes?.rate1
        ? { taxName: data?.taxes?.rate1 }
        : storeData.taxes?.rate1
          ? { taxName: storeData?.taxes?.rate1 }
          : null
    );

    setSelectedTaxRate2(
      data?.taxes?.rate2
        ? { taxName: data?.taxes?.rate2 }
        : storeData.taxes?.rate2
          ? { taxName: storeData?.taxes?.rate2 }
          : null
    );
    // setSelectedTaxRate1(
    //   storeData?.taxes?.rate1 ? { taxName: data?.taxes?.rate1 ?? storeData.taxes?.rate1 } : null
    // );

    // setSelectedTaxRate2({
    //   taxName: data?.taxes?.rate2 ?? storeData.taxes?.rate2 :null
    // });

    // setSelectedTaxRate2(
    //   storeData?.taxes?.rate2 ? { taxName: data?.taxes?.rate2 ?? storeData.taxes?.rate2 } : null
    // );

    // setSelectedTaxRate2({taxName: data?.taxes?.rate2 ?? storeData.taxes?.rate2}
    // );
    // setTaxNumber1(data?.taxes?.tax1 ?? storeData.taxes?.tax1);
    // setTaxNumber2(data?.taxes?.tax2 ?? storeData.taxes?.tax2);
    // setSelectedPreferredShippingMethod(data?.preferredShippingMethod);
    // setPreferredShippingMethod(data?.preferredShippingMethod);

    // let preferredShippingMethod: any =
    //   data?.preferredShippingMethod ?? storeData?.preferredShippingMethod;
    // if (preferredShippingMethod) {
    //   let includes: boolean = PREFERRED_SHIPPING_METHOD_ARRAY?.includes({
    //     id: preferredShippingMethod,
    //     value: preferredShippingMethod
    //   });

    //   if (includes) {
    //     setSelectedPreferredShippingMethod(preferredShippingMethod);
    //   } else {
    //     setSelectedPreferredShippingMethod('Other');
    //   }

    //   setPreferredShippingMethod(preferredShippingMethod);
    // }
    setPreferredShippingMethod(
      data?.preferredShippingMethod ?? storeData?.preferredShippingMethod
    );
    // setSelectedPreferredShippingMethod(
    //   data?.preferredShippingMethod ? storeData?.preferredShippingMethod ? { methodName: data?.preferredShippingMethod } : null :null
    // );
  }

  const detailsPayload = () => {
    if (!checkValidity()) {
      return;
    }
    let detailpayload: any = {
      shipTo: selectedShipTo,
      shipToInfo: {
        name: shipToName,
        companyName: shipToCompanyName,
        companyAddress: shipToAddress,
        city: shipToCity,
        zipCode: shipToPostCode,
        state: shipToState?.stateName,
        country: shipToCountry?.countryName,
      },
      shippingCharges: selectedShippingCharge === 'Yes' ? true : false,
      shippingRateType: selectedShippingCalculation,
      shippingRate: shippingCharges,
      preferredShippingMethod: preferredShippingMethod,
      taxes: {
        rate1: selectedTaxRate1?.taxName,
        rate2: selectedTaxRate2?.taxName,
        // tax1: selectedTaxRate1?.taxName,
        // tax2: selectedTaxRate2?.taxName
      },
      // payment: {
      //   method: selectedPaymentMethod,
      //   terms: selectedPaymentTerm
      // },
      amount: {
        calculatedsubTotal: total?.calculatedsubTotal,

        calculatedtax1: total?.calculatedtax1,

        calculatedtax2: total?.calculatedtax2,

        calculatedshippingCharge:
          selectedShippingCharge === 'Yes'
            ? selectedShippingCalculation === 'Percentage'
              ? parseFloat(
                  (
                    (Number(shippingCharges) / 100) *
                    Number(total?.calculatedsubTotal)
                  ).toFixed(2)
                )
              : selectedShippingCalculation === 'Amount'
                ? Number(shippingCharges)
                : 0
            : 0,

        calculatedtotal:
          selectedShippingCharge === 'Yes'
            ? selectedShippingCalculation === 'Percentage'
              ? total?.calculatedsubTotal +
                total?.calculatedtax1 +
                total?.calculatedtax2 +
                parseFloat(
                  (
                    (Number(shippingCharges) / 100) *
                    Number(total?.calculatedsubTotal)
                  ).toFixed(2)
                )
              : selectedShippingCalculation === 'Amount'
                ? total?.calculatedsubTotal +
                  total?.calculatedtax1 +
                  total?.calculatedtax2 +
                  Number(shippingCharges)
                : total?.calculatedtotal
            : total?.calculatedtotal,
      },
      // amount: {
      //   calculatedsubTotal: total?.calculatedsubTotal,
      //   calculatedtax1: total?.calculatedtax1,
      //   calculatedtax2: total?.calculatedtax2,
      //   calculatedshippingCharge: total?.calculatedshippingCharge,
      //   calculatedtotal:
      //     selectedShippingCharge === 'Yes' &&
      //     selectedShippingCalculation === 'Percentage'
      //       ? total?.calculatedsubTotal +
      //         total?.calculatedtax1 +
      //         total?.calculatedtax2 +
      //         total?.calculatedshippingCharge
      //       : total?.calculatedtotal,
      // },
    };

    return detailpayload;
  };

  function dataPayload(payload: any) {
    if (!checkValidity()) {
      return;
    }
    if (payload?.products?.length > 0) {
      payload.products.forEach((product: any) => {
        delete product.productName;
        delete product.unitPrice;
        // delete product.totalPrice;
        // delete product.totalprice;
      });

      if (payload.id) {
        delete payload.id;
      }
    }

    return payload;
  }

  // async function setShipToData(shipToValue: string) {
  //   const storeData = (_storeState?.value as any) || {}; // <-- FIX
  //   const draftData = (_draftOrder?.value?.data as any) || {}; // <-- FIX

  //   const storeInfo = storeData.storeInfo || {}; // safe
  //   const shipToInfo = draftData?.shipToInfo || storeData?.shipToInfo || {}; // safe
  //   debugger;
  //   switch (shipToValue) {
  //     case 'Store': {
  //       setShipToName(storeData?.storeName || '');
  //       setShipToCompanyName(storeData?.storeName || '');
  //       setShipToAddress(storeData?.storeAddress?.address || '');
  //       setShipToCity(storeData?.storeAddress?.city || '');
  //       setShipToPostCode(storeData?.storeAddress?.zipCode || '');
  //       // setShipToCountry(storeData?.storeAddress?.country);
  //       // setShipToState(storeData?.storeAddress?.state);
  //       // ---------- COUNTRY ----------
  //       const countryObj = _countryState?.value?.data?.find(
  //         (c: any) =>
  //           c?.countryName?.toLowerCase() ===
  //           storeData?.storeAddress?.country?.toLowerCase()
  //       );

  //       if (countryObj) {
  //         handleShipToCountrySelect(countryObj);
  //         setShipToCountry(countryObj);

  //         // ---------- STATE ----------
  //         const stateObj = _statesState?.value?.data?.find(
  //           (st: any) =>
  //             st?.stateName?.toLowerCase() ===
  //             storeData?.storeAddress?.state?.toLowerCase()
  //         );

  //         setShipToState(stateObj);
  //       }

  //       break;
  //     }
  //     case 'Other':
  //       clearShipTo();
  //       break;
  //     case 'Pickup': {
  //       const s = shipToInfo || {};
  //       setShipToName(s.name || '');
  //       setShipToCompanyName(s.companyName || '');
  //       setShipToAddress(s.companyAddress || '');
  //       setShipToCity(s.city || '');
  //       setShipToPostCode(s.zipCode || '');

  //       // ---------- COUNTRY ----------
  //       const countryObj = _countryState?.value?.data?.find(
  //         (c: any) =>
  //           c?.countryName?.toLowerCase() === s?.country?.toLowerCase()
  //       );

  //       if (countryObj) {
  //         handleShipToCountrySelect(countryObj);

  //         // ---------- STATE ----------
  //         const stateObj = _statesState?.value?.data?.find(
  //           (st: any) =>
  //             st?.stateName?.toLowerCase() === s?.state?.toLowerCase()
  //         );

  //         setShipToCountry(countryObj);
  //         setShipToState(stateObj);
  //       }

  //       break;
  //     }
  //     default:
  //       clearShipTo();
  //       break;
  //   }
  // }

  const storeData = (_storeState?.value as any) || {};
  const storeAddress = (storeData?.storeAddress as any) || {};
  const shipToInfo =
    _draftOrder?.value?.data?.[0]?.shipToInfo || storeData?.shipToInfo || {};

  useEffect(() => {
    if (!shipToCountry) return;
    if (!_statesState?.value?.data?.length) return;

    const storeAddress = storeData?.storeAddress || {};
    const pickupInfo = shipToInfo || {};

    let selectedState = '';

    if (shipToType === 'Store') {
      selectedState = storeAddress?.state || '';
    }

    if (shipToType === 'Pickup') {
      selectedState = pickupInfo?.state || '';
    }

    if (!selectedState) return;

    const stateObj = _statesState.value.data.find(
      (st: any) => st?.stateName?.toLowerCase() === selectedState?.toLowerCase()
    );

    if (stateObj) {
      setShipToState(stateObj);
    }
  }, [shipToCountry, _statesState?.value?.data]);

  async function setShipToData(shipToValue: string) {
    const storeData = (_storeState?.value as any) || {};
    const draftData = (_draftOrder?.value?.data?.[0] as any) || {};
    const shipToInfo = draftData?.shipToInfo || storeData?.shipToInfo || {};

    setShipToType(shipToValue);

    switch (shipToValue) {
      case 'Store': {
        const s = storeData?.storeAddress || {};

        setShipToName(storeData?.storeName || '');
        setShipToCompanyName(storeData?.storeName || '');
        setShipToAddress(s?.address || '');
        setShipToCity(s?.city || '');
        setShipToPostCode(s?.zipCode || '');
        const countryObj = _countryState?.value?.data?.find(
          (c: any) =>
            c?.countryName?.toLowerCase() === s?.country?.toLowerCase()
        );

        if (countryObj) {
          setShipToCountry(countryObj);
          handleShipToCountrySelect(countryObj);
        }
        break;
      }

      case 'Pickup': {
        const s = shipToInfo || {};

        setShipToName(s.name || '');
        setShipToCompanyName(s.companyName || '');
        setShipToAddress(s.companyAddress || '');
        setShipToCity(s.city || '');
        setShipToPostCode(s.zipCode || '');
        const countryObj = _countryState?.value?.data?.find(
          (c: any) =>
            c?.countryName?.toLowerCase() === (s?.country || '').toLowerCase()
        );

        if (countryObj) {
          setShipToCountry(countryObj);
          handleShipToCountrySelect(countryObj);
        }
        break;
      }

      case 'Other':
        clearShipTo();
        break;

      default:
        clearShipTo();
        break;
    }
  }

  function clearShipTo() {
    setShipToName('');
    setShipToCompanyName('');
    setShipToAddress('');
    setShipToCity('');
    setShipToState('');
    setShipToCountry('');
    setShipToPostCode('');
  }

  async function handleShipToCountrySelect(country: any) {
    setShipToState(null);
    dispatch(clearStatesState());

    if (country === undefined || country === null) {
      setShipToCountry(null);
      return;
    }

    setShipToCountry(country);
    let payload: any = { page: 1, limit: 100, countryId: country?._id };
    await dispatch(fetchStates(payload));
  }

  function openAddShippingMethodDialog(data: any) {
    return myContext.setDialog({
      open: true,
      title: 'ADD_SHIPPING_METHOD',
      dialogContent: {
        pageName: 'AddShippingMethod',
        params: data,
        onBack: async () => {
          await dispatch(fetchShippingMethods({ page: 1, limit: 5 }));
        },
      },
    });
  }

  function getRegexPatternForPostalCode(country: string): RegExp {
    if (country === 'Canada') {
      return Regex.canadaPostCode;
    } else if (country === 'USA') {
      return Regex.usaPostCode;
    }
    return Regex.canadaPostCode;
  }

  function getMaxLengthForPostalCode(country: string): number {
    if (country === 'Canada') {
      return 7;
    } else if (country === 'USA') {
      return 10;
    }
    return 7;
  }

  const checkValidity = (): boolean => {
    if (!validateField(dispatch, 'SHIP_TO', selectedShipTo)) {
      return false;
    }

    if (selectedShipTo !== 'Pickup') {
      if (!validateField(dispatch, 'NAME', shipToName, Regex.name)) {
        return false;
      }
      if (
        !validateField(dispatch, 'COMPANY_NAME', shipToCompanyName, Regex.name)
      ) {
        return false;
      }

      if (!validateField(dispatch, 'COUNTRY', shipToCountry)) {
        return false;
      }
      if (!validateField(dispatch, 'STATE', shipToState)) {
        return false;
      }
      if (!validateField(dispatch, 'CITY', shipToCity, Regex.onlyAlphabets)) {
        return false;
      }
      if (!validateField(dispatch, 'ADDRESS', shipToAddress)) {
        return false;
      }

      if (
        !validateField(
          dispatch,
          'POSTAL_CODE',
          shipToPostCode,
          shipToCountry?.countryName === 'USA'
            ? Regex.usaPostCode
            : Regex.canadaPostCode
        )
      ) {
        return false;
      }
    }

    return true;
  };

  const handleSaveToCart = async () => {
    // if (_draftOrder?.value?.data?.length > 0) {
    //   openSaveToCartDialog();
    // }
    //  else {

    let payload = props?.isEdit?.params?.data;
    let detailpayload = await detailsPayload();
    let dataaPayload = await dataPayload(payload);

    let draftid;
    // let draftid = _draftOrders?.value?.data[0]?._id;
    const cartOrderId = id;
    let fg: any = _draftOrder?.value?.data[0];
    const draftOrderId: any = fg?._id;

    if (cartOrderId === draftOrderId) {
      draftid = draftOrderId;
    } else {
      await dispatch(deleteDraftOrderById({ id: draftOrderId }));
    }

    if (dataaPayload) {
      let newPayload = {
        ...payload,
        ...detailpayload,
        ...dataaPayload,
        ...(draftid && { id: draftid }),
      };

      // if (
      //   props?.isEdit?.params?.isDraftOrder &&
      //   _draftOrder?.value?.data?.length > 0 &&
      //   '_id' in _draftOrder?.value?.data[0]
      // ) {
      //   newPayload = { ...newPayload, id: _draftOrder?.value?.data[0]['_id'] };
      // }

      let response: any = await dispatch(draftorders(newPayload));
      dispatch(fetchdraftOrders({ page: 1, limit: 5 }));

      if (response?.error === null || response?.error === undefined) {
        // handleSaveToCartDialogClose();
        dispatch(clearCreateOrdersState());
        handleClose();
        // }
      }
    }
  };

  function openSaveToCartDialog() {
    myContext.setConfirmDialog({
      open: true,
      type: 'YES',
      title: t('CONFIRMATION'),
      message: t('ORDER_PRESENT_INCART'),
      onYesClick: async (event: any, param: string | undefined) => {
        handleSaveToCart();
      },
      onNoClick: () => {
        myContext.setConfirmDialog({ open: false });
      },
    });
  }

  return (
    <>
      <DialogContent dividers>
        <Grid>
          <Grid sx={{ display: 'flex', justifyContent: 'space-between' }}>
            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <BakeasyHeaderLabel message="NEW_ORDER_SUMMARY" />
            </Grid>

            <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
              <Button.Cancel
                onClick={function (
                  event: React.MouseEvent<HTMLButtonElement, MouseEvent>
                ): void {
                  openCancelConfirmDialog();
                }}
              />
              <Button.GoToOrderDetails
                onClick={(event: React.MouseEvent<HTMLButtonElement>) => {
                  myContext.setDialog({ open: false });
                }}
              />
              {/* <Button.SaveToCart
                onClick={async (event: React.MouseEvent<HTMLButtonElement>) => {
                  openSaveToCartDialog();
                  // let payload = props?.isEdit?.params?.data;
                  // let detailpayload = await detailsPayload();
                  // let dataaPayload = await dataPayload(payload);
                  // let newPayload = { ...payload, ...detailpayload, ...dataaPayload };
                  // if (
                  //   props?.isEdit?.params?.isDraftOrder &&
                  //   _draftOrder?.value?.data?.length > 0 &&
                  //   '_id' in _draftOrder?.value?.data[0]
                  // ) {
                  //   newPayload = { ...newPayload, id: _draftOrder?.value?.data[0]['_id'] };
                  // }

                  // let response: any = await dispatch(draftorders(newPayload));
                  // dispatch(fetchdraftOrders({ page: 1, limit: 5 }));
                  // if (response?.error === null || response?.error === undefined) {
                  //   handleClose();
                  // }
                }}
              /> */}
              <Button.SaveToCart
                onClick={async (event: React.MouseEvent<HTMLButtonElement>) => {
                  // if (_draftOrder?.value?.data?.length > 0) {
                  //   openSaveToCartDialog();
                  // }

                  const cartOrderId = id;
                  let fg: any = _draftOrder?.value?.data[0];
                  const draftOrderId: any = fg?._id;

                  if (!draftOrderId) {
                    handleSaveToCart();
                  } else if (draftOrderId === cartOrderId) {
                    handleSaveToCart();
                  } else {
                    openSaveToCartDialog();
                  }
                  // else {
                  //   let payload = props?.isEdit?.params?.data;
                  //   let detailpayload = await detailsPayload();
                  //   let dataaPayload = await dataPayload(payload);
                  //   if (dataaPayload) {
                  //     let newPayload = { ...payload, ...detailpayload, ...dataaPayload };

                  //     if (
                  //       props?.isEdit?.params?.isDraftOrder &&
                  //       _draftOrder?.value?.data?.length > 0 &&
                  //       '_id' in _draftOrder?.value?.data[0]
                  //     ) {
                  //       newPayload = { ...newPayload, id: _draftOrder?.value?.data[0]['_id'] };
                  //     }

                  //     let response: any = await dispatch(draftorders(newPayload));
                  //     dispatch(fetchdraftOrders({ page: 1, limit: 5 }));

                  //     if (response?.error === null || response?.error === undefined) {
                  //       handleClose();
                  //     }
                  //   }
                  // }
                }}
              />

              <Button.SendOrder
                onClick={async (event: React.MouseEvent<HTMLButtonElement>) => {
                  if (!checkValidity()) {
                    return;
                  }
                  let payload = props?.isEdit?.params?.data;
                  if (payload?.products?.length > 0) {
                    const isQuantityZero = payload?.products?.some(
                      (item: any) =>
                        item?.quantity === 0 || item?.quantity === '0'
                    );

                    if (isQuantityZero) {
                      dispatch(
                        showErrorSnackbar({
                          message: t('QUANTITY_MUST_GREATER_THAN_ZERO'),
                        })
                      );
                      return;
                    }
                  }

                  let dataaPayload = dataPayload(payload);
                  let detailpayload = detailsPayload();
                  if (dataaPayload) {
                    let newPayload = {
                      ...payload,
                      ...detailpayload,
                      ...dataaPayload,
                      status: 'New',
                    };

                    if (
                      props?.isEdit?.params?.isDraftOrder &&
                      _draftOrder?.value?.data?.length > 0 &&
                      '_id' in _draftOrder?.value?.data[0]
                    ) {
                      let _id: any = _draftOrder?.value?.data[0]['_id'];
                      newPayload = {
                        ...newPayload,
                        id: _id,
                        draftOrderId: _id,
                      };
                    }

                    let d: any = requestedDeliveryDate;
                    let d1: any = dayjs(requestedDeliveryDate);
                    let d2: any = dayjs(new Date());
                    let d3: any = new Date();
                    newPayload = {
                      ...newPayload,
                      requestedDeliveryDate: formatDateTime(
                        requestedDeliveryDate?.toString(),
                        false
                      ),
                    };

                    let response: any = await dispatch(
                      createorders(newPayload)
                    );

                    await dispatch(fetchdraftOrders({ page: 1, limit: 5 }));
                    if (
                      response?.error === null ||
                      response?.error === undefined
                    ) {
                      dispatch(clearDraftOrdersState());
                      handleClose();
                      navigate('/orders');
                    }
                  }
                }}
              />
            </Grid>
          </Grid>

          <BakeasyDivider />

          <Grid container>
            <BakeasyHeaderLabel message="ORDER_DETAILS" />
          </Grid>

          <Grid container spacing={2} pl={2}>
            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <BakeasyTextField
                disabled={true}
                label={t('SUPPLIER_NAME')}
                value={supplierName}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <BakeasyTextField
                disabled={true}
                required={true}
                label={t('ORDER_BY')}
                type="text"
                name=""
                value={orderBy}
                maxLength={10}
                onChange={function (event: any): void {
                  setorderBy(event?.target?.value);
                }}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <BakeasyTextField
                disabled={true}
                // required={true}
                label={t('STORE_PO_NUMBER')}
                type="text"
                value={poNumber}
                maxLength={30}
                onChange={(event: any) => {
                  setPoNumber(event?.target?.value);
                }}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <BakeasyDatePicker
                disabled={true}
                label={t('REQUESTED_DELIVERY_DATE')}
                value={requestedDeliveryDate}
                minDate={dayjs(new Date()).add(1, 'days')}
                onChange={(e) => setRequestedDeliveryDate(dayjs(new Date(e)))}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <Dropdown.YesNo
                disabled={true}
                label={'HIGH_PRIORITY'}
                value={selectedPriority}
                onChange={(event: any) => {
                  setSelectedPriority(event?.target?.value);
                }}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <BakeasyTextField
                disabled={true}
                label={t('NOTE')}
                placeHolder="Enter note"
                type="text"
                name="description"
                value={note}
                multiline
                rows={2}
                onChange={(event: any) => {
                  setNote(event.target.value);
                }}
              />
            </Grid>
          </Grid>

          <BakeasyDivider />

          <Grid container>
            <BakeasyHeaderLabel message="SHIPPING_DETAILS" />
          </Grid>

          <Grid container spacing={2} pl={2}>
            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <Dropdown.ShipTo
                disabled={false}
                value={selectedShipTo}
                onChange={(event: any) => {
                  setSelectedShipTo(event.target.value);
                  setShipToData(event?.target?.value);
                  // onChange={(event: any) => {
                  //   const selectedValue = event.target.value;
                  //   setSelectedShipTo(selectedValue);
                  //   setShipToData(selectedValue);

                  //   if (selectedValue === 'Store') {
                  //     if (
                  //       props?.isEdit?.params?.isDraftOrder &&
                  //       _draftOrder?.value?.data[0]
                  //     ) {
                  //       setDetailsData(_draftOrder?.value?.data[0]);
                  //       return;
                  //     }

                  //     if (_storeState?.value) {
                  //       setDetailsData(_storeState?.value);
                  //     }
                  //   }
                }}
              />
            </Grid>

            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <TextField.Name
                disabled={false}
                placeHolder={t('ENTER_NAME')}
                value={shipToName}
                onChange={(event: any) => {
                  setShipToName(event.target.value);
                }}
              />
            </Grid>

            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <TextField.Name
                disabled={false}
                label={t('COMPANY_NAME')}
                placeHolder={t('ENTER_COMPANY_NAME')}
                value={shipToCompanyName}
                onChange={(event: any) => {
                  setShipToCompanyName(event.target.value);
                }}
              />
            </Grid>

            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              {/* <TextField.Country
                value={shipToCountry}
                onChange={(event: any) => {
                  setShipToCountry(event.target.value);
                }}
              /> */}
              <BakeasyAutoCompleteCountry
                // disabled={false}
                label={'COUNTRY'}
                required={true}
                value={shipToCountry}
                options={_countryState.value?.data}
                onChange={(newValue: any) => {
                  // if (typeof newValue === 'string' && newValue?.length === 0) {
                  //   dispatch(fetchCountries({ page: 1, limit: 5 }));
                  // }

                  // if (typeof newValue === 'string' && newValue?.length > 2) {
                  //   dispatch(fetchCountries({ page: 1, limit: 5, search: newValue }));
                  // }

                  if (typeof newValue === 'object') {
                    handleShipToCountrySelect(newValue);
                    setShipToPostCode('');
                  }

                  if (newValue === null) {
                    setShipToCountry(null);
                    setShipToPostCode('');
                    //dispatch(fetchCountries({ page: 1, limit: 5 }));
                  }
                }}
              />
            </Grid>

            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              {/* <TextField.State
                value={shipToState}
                onChange={(event: any) => {
                  setShipToState(event.target.value);
                }}
              /> */}

              <BakeasyAutoCompleteState
                label={t('STATE')}
                required={true}
                // label={shipToCountry?.countryName === 'Canada' ? 'PROVINCE' : 'STATE'}
                disabled={shipToCountry === null}
                value={shipToState}
                options={_statesState.value?.data}
                onChange={async (newValue: any) => {
                  if (typeof newValue === 'object') {
                    setShipToState(newValue);
                  }
                  if (newValue === null) {
                    setShipToState(null);
                  }
                }}
              />
            </Grid>

            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <TextField.City
                disabled={false}
                value={shipToCity}
                onChange={(event: any) => {
                  setShipToCity(event.target.value);
                }}
                placeHolder={t('ENTER_CITY')}
              />
            </Grid>

            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <TextField.Address
                disabled={false}
                label={t('COMPANY_ADDRESS')}
                value={shipToAddress}
                onChange={(event: any) => {
                  setShipToAddress(event.target.value);
                }}
                placeHolder={t('ENTER_COMPANY_ADDRESS')}
              />
            </Grid>

            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <TextField.Pincode
                disabled={false}
                value={shipToPostCode}
                maxLength={getMaxLengthForPostalCode(
                  shipToCountry?.countryName
                )}
                regexPattern={getRegexPatternForPostalCode(
                  shipToCountry?.countryName
                )}
                onChange={(event: any) => {
                  setShipToPostCode(
                    preparePostalCode(
                      event.target.value,
                      shipToCountry?.countryName
                    )
                  );
                }}
                placeHolder={t('ENTER_POSTAL_CODE')}
              />
            </Grid>
          </Grid>

          <Grid container spacing={2} pl={2} mt={0}>
            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <Dropdown.YesNo
                disabled={true}
                label={t('SHIPPING_CHARGE')}
                value={selectedShippingCharge}
                onChange={function (event: any): void {
                  setSelectedShippingCharge(event?.target?.value);
                  setSelectedShippingCalculation('');
                  setShippingCharges('');
                }}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <Dropdown.ShippingCalculation
                // disabled={
                //   selectedShippingCharge !== 'Yes' && selectedShippingCharge !== 'Oui'
                //     ? true
                //     : false
                // }

                // required={
                //   selectedShippingCharge !== 'Yes' && selectedShippingCharge !== 'Oui'
                //     ? false
                //     : true
                // }
                disabled={true}
                required={true}
                value={
                  selectedShippingCalculation
                    ? t(
                        `${selectedShippingCalculation?.toUpperCase().replace(/\s+/g, '_')}`
                      )
                    : selectedShippingCalculation
                }
                // value={selectedShippingCalculation}
                onChange={(event: any) => {
                  setSelectedShippingCalculation(event?.target?.value);
                }}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <TextField.Number
                label={t('SHIPPING_CHARGES')}
                maxLength={4}
                disabled={true}
                // disabled={
                //   selectedShippingCharge !== 'Yes' && selectedShippingCharge !== 'Oui'
                //     ? true
                //     : false
                // }
                // required={
                //   selectedShippingCharge !== 'Yes' && selectedShippingCharge !== 'Oui'
                //     ? false
                //     : true
                // }
                value={shippingCharges}
                onChange={(event: any) => {
                  setShippingCharges(event.target.value);
                }}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <TextField.Name
                label={t('SHIPPING_METHOD')}
                required={true}
                disabled={true}
                value={preferredShippingMethod}
                // onChange={(event: any) => {
                //   setPreferredShippingMethod(event.target.value);
                // }}
              />
              {/* <BakeasyAutoCompleteShippingMethod
                // disabled={isView}
                value={selectedPreferredShippingMethod}
                options={
                  _shippingMethodsState.value?.data?.length > 0
                    ? _shippingMethodsState.value?.data
                    : null
                }
                onAddClick={(props: any) => {
                  openAddShippingMethodDialog(props);
                }}
                onChange={(newValue: any) => {
                  if (typeof newValue === 'string' && newValue?.length > 2) {
                    dispatch(fetchShippingMethods({ page: 1, limit: 5 }));
                  }

                  if (typeof newValue === 'string' && newValue?.length === 0) {
                    dispatch(fetchShippingMethods({ page: 1, limit: 5 }));
                  }

                  if (typeof newValue === 'object' && newValue?.id !== 0) {
                    setSelectedPreferredShippingMethod(newValue);
                  }
                }}
                required={false}
              /> */}
            </Grid>
          </Grid>

          {/* <Grid container spacing={2} pl={2} mt={0}>
            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <Dropdown.PreferredShippingMethod
                value={selectedPreferredShippingMethod}
                onChange={function(event: any): void {
                  setSelectedPreferredShippingMethod(event?.target?.value);
                  setPreferredShippingMethod(event?.target?.value);
                }}
              />
            </Grid>
          </Grid> */}

          <BakeasyDivider />

          {/* working but commented as per client request 1049 */}
          {/* <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <BakeasyHeaderLabel message={t('TAXES')} />
              </Grid>

              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <Grid container spacing={2} pl={2}>
                  <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                    <BakeasyAutoCompleteTax
                      label="STORE_TAX1"
                      disabled={true}
                      value={selectedTaxRate1}
                      options={_taxesState.value?.data?.length > 0 ? _taxesState.value?.data : null}
                      onChange={function(newValue: any): void {
                        // throw new Error('Function not implemented.');
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                    <BakeasyAutoCompleteTax
                      label="STORE_TAX2"
                      disabled={true}
                      value={selectedTaxRate2}
                      options={_taxesState.value?.data?.length > 0 ? _taxesState.value?.data : null}
                      onChange={function(newValue: any): void {
                        // throw new Error('Function not implemented.');
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                    <TextField.Name
                      disabled={true}
                      label={t('STORE_TAX1_RATE')}
                      value={
                        selectedTaxRate1?.taxName
                          ? selectedTaxRate1?.taxName?.split(' - ', 10).pop()
                          : ''
                      }
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                    <TextField.Name
                      disabled={true}
                      label={t('STORE_TAX2_RATE')}
                      value={
                        selectedTaxRate2?.taxName
                          ? selectedTaxRate2?.taxName?.split(' - ', 10).pop()
                          : ''
                      }
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>

            <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <BakeasyHeaderLabel message={t('PAYMENT')} />
              </Grid>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <Grid container spacing={2} pl={2}>
                  <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                    <Dropdown.PaymentMethod
                      disabled={true}
                      value={selectedPaymentMethod}
                      onChange={(event: any) => {
                        setSelectedPaymentMethod(event.target.value);
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                    <Dropdown.PaymentTerms
                      disabled={true}
                      value={selectedPaymentTerm}
                      onChange={(event: any) => {
                        setSelectedPaymentTerm(event.target.value);
                      }}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid> */}

          <Grid sx={{ p: 1 }}>
            <Grid>
              {ordersList?.length > 0 && (
                <BakeasySimpleTable
                  type={'orderSummary'}
                  headers={tableHeaders}
                  tableData={ordersList}
                  data={total}
                />
              )}
            </Grid>
          </Grid>
        </Grid>
      </DialogContent>
    </>
  );
};
function fetchShippingMethods(arg0: { page: number; limit: number }): any {
  throw new Error('Function not implemented.');
}
